module.exports = __webpack_public_path__ + "img/arrow-up.a84ee073.svg";